import Seo, { breadcrumbLd, orgLd } from "../lib/seo";
import { IMG } from "../lib/site";
import { Breadcrumbs } from "../components/site/Layout";
import { PageHero, CtaBand } from "../components/site/Sections";
import { Reveal, Overline } from "../components/site/Reveal";

const POINTS = [
  { t: "Who We Are", d: "NanoMax Holo Solutions LLC is a UAE-based manufacturer of hologram stickers and security labels, focused on helping businesses protect products and verify authenticity." },
  { t: "UAE Presence", d: "We are based in Sharjah Media City and serve businesses across Sharjah, Dubai, Abu Dhabi and the wider United Arab Emirates." },
  { t: "Our Specialization", d: "We specialise in holographic security labels — including 3D, QR, tamper-evident, serialised and custom security stickers — designed around each customer's requirements." },
  { t: "Product Customization", d: "From artwork and materials to security features, sizes and finishes, every label is customized to suit your product, packaging and authentication goals." },
  { t: "Commitment to Quality", d: "We focus on precise, consistent holographic security features and clear specifications so your labels perform as intended." },
  { t: "Customer Support", d: "Our UAE-based team communicates clearly throughout the project, from artwork discussion to production requirements and delivery." },
  { t: "Brand Protection Focus", d: "Everything we do centres on helping brands deter counterfeiting, add visible security features and make genuine products easier to identify." },
];

export default function About() {
  return (
    <>
      <Seo title="About NanoMax Holo Solutions | UAE Hologram & Security Labels"
        description="Learn about NanoMax Holo Solutions, a Sharjah-based UAE manufacturer of custom hologram stickers and security labels for product authentication and brand protection."
        path="/about-us" image={IMG.hero} jsonLd={[orgLd, breadcrumbLd([{ name: "Home", path: "/" }, { name: "About Us", path: "/about-us" }])]} />
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "About Us" }]} />
      <PageHero overline="About" title="About NanoMax Holo Solutions"
        subtitle="Advanced hologram and security label solutions, engineered in the UAE to help protect products and strengthen brands." />
      <section className="px-6 md:px-10 lg:px-16 py-16 grid md:grid-cols-2 gap-6">
        {POINTS.map((p, i) => (
          <Reveal key={p.t} delay={i * 0.04}>
            <div className="card p-8 h-full">
              <Overline>{String(i + 1).padStart(2, "0")}</Overline>
              <h2 className="font-head text-xl font-semibold mt-3">{p.t}</h2>
              <p className="text-[#8A8A9B] mt-3 leading-relaxed">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </section>
      <CtaBand sourcePage="/about-us" />
    </>
  );
}
